import { AppUI } from '@seedlang/state';

const AdminOnly = ({ children }) => {
  if (!AppUI.user?.anyAdmin) {
    return null;
  }

  return children;
};

export default AdminOnly;